(function () {
  var sheet = document.querySelector("[data-mobile-size-sheet]");
  var html = document.documentElement;
  var mobileQuery = window.matchMedia ? window.matchMedia("(max-width: 760px)") : null;
  var menuToggle = document.querySelector("[data-mobile-menu-toggle]");
  var menuPanel = document.querySelector("[data-mobile-menu-panel]");

  // Keep a compact purchase entry available whenever the inline CTA is offscreen.
  var browseDock = document.querySelector('[data-browse-purchase]');
  var purchaseButton = document.querySelector('.board-product-summary .purchase-form [data-add-to-cart]');
  if (browseDock && purchaseButton && window.IntersectionObserver) {
    var pastPurchase = false; // Here this tracks visibility of the inline purchase button.
    function updateBrowseDock() {
      var visible = isMobile() && !pastPurchase && !html.matches('.cart-drawer-open,.mobile-size-sheet-open,.mobile-menu-open');
      browseDock.dataset.docked = String(visible);
      browseDock.inert = !visible;
      browseDock.setAttribute('aria-hidden', String(!visible));
    }
    new IntersectionObserver(function(entries) {
      pastPurchase = entries[0].isIntersecting;
      updateBrowseDock();
    }, {threshold:0}).observe(purchaseButton);
    // A restored scroll position can jump across the CTA without intersecting it.
    // Sample once per scrolling frame so the dock also follows those jumps.
    var browseScrollFrame = 0;
    function queueBrowsePosition() {
      if (browseScrollFrame) return;
      browseScrollFrame = requestAnimationFrame(function () {
        browseScrollFrame = 0;
        var box = purchaseButton.getBoundingClientRect();
        pastPurchase = box.bottom > 0 && box.top < innerHeight;
        updateBrowseDock();
      });
    }
    window.addEventListener('scroll', queueBrowsePosition, {passive:true});
    window.addEventListener('resize', queueBrowsePosition, {passive:true});
    window.addEventListener('pageshow', queueBrowsePosition);
    new MutationObserver(updateBrowseDock).observe(html, {attributes:true,attributeFilter:['class']});
    if (mobileQuery) mobileQuery.addEventListener('change', updateBrowseDock);
    // Shopify's draft toolbar is outside the storefront; keep the preview usable.
    var browsePreviewFrame = 0;
    function queueBrowsePreview() {
      if (browsePreviewFrame) return;
      browsePreviewFrame = requestAnimationFrame(function () {
        browsePreviewFrame = 0;
        var preview = document.getElementById('PBarNextFrameWrapper');
        var offset = 0;
        if (preview) {
          var bounds = preview.getBoundingClientRect();
          var style = getComputedStyle(preview);
          if (style.display !== 'none' && style.visibility !== 'hidden' && bounds.width > 0 && bounds.height > 0 && bounds.top < innerHeight && bounds.bottom >= innerHeight - 1) {
            offset = Math.max(0, innerHeight - bounds.top);
          }
        }
        browseDock.style.setProperty('--browse-preview-bottom', offset + 'px');
        document.body.style.setProperty('--purchase-preview-bottom', offset + 'px');
      });
    }
    function watchBrowsePreview() {
      var preview = document.getElementById('PBarNextFrameWrapper');
      if (!preview) return false;
      if (window.ResizeObserver) new ResizeObserver(queueBrowsePreview).observe(preview);
      new MutationObserver(queueBrowsePreview).observe(preview, {attributes:true,attributeFilter:['style','class','hidden']});
      preview.addEventListener('toggle', queueBrowsePreview);
      queueBrowsePreview();
      return true;
    }
    if (!watchBrowsePreview()) {
      var browsePreviewInsertions = new MutationObserver(function () {
        if (watchBrowsePreview()) browsePreviewInsertions.disconnect();
      });
      browsePreviewInsertions.observe(document.body, {childList:true,subtree:true});
      window.addEventListener('load', function () {
        // No persistent subtree observer on ordinary storefront visits.
        window.setTimeout(function () { browsePreviewInsertions.disconnect(); }, 15000);
      }, {once:true});
    }
    window.addEventListener('resize', queueBrowsePreview, {passive:true});
  }

  function isMobile() {
    return mobileQuery ? mobileQuery.matches : window.innerWidth <= 760;
  }

  function collapseMobileAccordions() {
    if (!isMobile()) return;
    document.querySelectorAll(".puzzle-product__accordions details[open]").forEach(function (details) {
      details.removeAttribute("open");
    });
  }

  function collapseMobileDisclosures() {
    if (!isMobile()) return;
    document.querySelectorAll("[data-mobile-collapse]").forEach(function (details) {
      details.removeAttribute("open");
    });
  }

  var sizePageLock = null;
  var sizeViewportFrame = 0;
  var sizePreviewNode = null;
  var sizePreviewResize = null;
  var sizePreviewAttributes = null;
  var sizePreviewInsertions = null;
  var revealSelectedSize = false;

  function lockSizePage() {
    if (sizePageLock) return;
    sizePageLock = { x: window.scrollX, y: window.scrollY, bodyStyle: document.body.getAttribute("style"), overflow: html.style.overflow };
    html.style.overflow = "hidden";
    document.body.style.position = "fixed";
    document.body.style.top = "-" + sizePageLock.y + "px";
    document.body.style.left = "-" + sizePageLock.x + "px";
    document.body.style.width = "100%";
  }

  function unlockSizePage() {
    if (!sizePageLock) return;
    var saved = sizePageLock;
    sizePageLock = null;
    if (saved.bodyStyle === null) document.body.removeAttribute("style");
    else document.body.setAttribute("style", saved.bodyStyle);
    html.style.overflow = saved.overflow;
    window.scrollTo({ left: saved.x, top: saved.y, behavior: "instant" });
  }

  function updateSizeViewport() {
    sizeViewportFrame = 0;
    if (!sheet || sheet.dataset.state !== "open") return;
    var viewport = window.visualViewport;
    var top = Math.max(0, viewport ? viewport.offsetTop : 0);
    var bottom = top + (viewport ? viewport.height : window.innerHeight);
    var preview = document.getElementById("PBarNextFrameWrapper");
    if (preview !== sizePreviewNode) {
      if (sizePreviewResize) sizePreviewResize.disconnect();
      if (sizePreviewAttributes) sizePreviewAttributes.disconnect();
      if (sizePreviewNode) sizePreviewNode.removeEventListener("toggle", queueSizeViewport);
      sizePreviewNode = preview;
      if (preview) {
        if (window.ResizeObserver) {
          sizePreviewResize = new ResizeObserver(queueSizeViewport);
          sizePreviewResize.observe(preview);
        }
        sizePreviewAttributes = new MutationObserver(queueSizeViewport);
        sizePreviewAttributes.observe(preview, { attributes: true, attributeFilter: ["style", "class", "hidden"] });
        preview.addEventListener("toggle", queueSizeViewport);
      }
    }
    if (preview) {
      var bounds = preview.getBoundingClientRect();
      var style = window.getComputedStyle(preview);
      if (style.visibility !== "hidden" && style.display !== "none" && bounds.width > 0 && bounds.height > 0 && bounds.bottom >= bottom - 1 && bounds.top < bottom && bounds.right > 0 && bounds.left < window.innerWidth) {
        bottom = Math.max(top, bounds.top);
      }
    }
    var availableHeight = Math.max(0, bottom - top);
    sheet.dataset.compact = String(availableHeight < 300);
    sheet.style.setProperty("--size-sheet-visible-top", top + "px");
    sheet.style.setProperty("--size-sheet-visible-height", availableHeight + "px");
    if (revealSelectedSize) {
      var options = sheet.querySelector(".mobile-size-sheet__options");
      var selected = options && options.querySelector('[aria-pressed="true"]');
      if (options && selected) {
        var area = options.getBoundingClientRect();
        var choice = selected.getBoundingClientRect();
        if (choice.bottom > area.bottom) options.scrollTop += choice.bottom - area.bottom;
        else if (choice.top < area.top) options.scrollTop -= area.top - choice.top;
      }
      revealSelectedSize = false;
    }
  }

  function queueSizeViewport() {
    if (sheet && sheet.dataset.state === "open" && !sizeViewportFrame) sizeViewportFrame = window.requestAnimationFrame(updateSizeViewport);
  }

  function stopSizeViewport() {
    if (sizeViewportFrame) window.cancelAnimationFrame(sizeViewportFrame);
    sizeViewportFrame = 0;
    if (sizePreviewResize) sizePreviewResize.disconnect();
    if (sizePreviewAttributes) sizePreviewAttributes.disconnect();
    if (sizePreviewInsertions) sizePreviewInsertions.disconnect();
    if (sizePreviewNode) sizePreviewNode.removeEventListener("toggle", queueSizeViewport);
    sizePreviewNode = null;
    revealSelectedSize = false;
  }

  window.addEventListener("resize", queueSizeViewport);
  if (window.visualViewport) {
    window.visualViewport.addEventListener("resize", queueSizeViewport);
    window.visualViewport.addEventListener("scroll", queueSizeViewport);
  }

  function setSheetOpen(isOpen) {
    if (!sheet || (isOpen && !isMobile())) return;
    var wasOpen = sheet.dataset.state === "open";
    if (isOpen && !wasOpen) lockSizePage();
    sheet.dataset.state = isOpen ? "open" : "closed";
    sheet.setAttribute("aria-hidden", isOpen ? "false" : "true");
    html.classList.toggle("mobile-size-sheet-open", isOpen);
    if (isOpen) {
      revealSelectedSize = true;
      updateSizeViewport();
      if (!wasOpen) {
        sizePreviewInsertions = new MutationObserver(queueSizeViewport);
        sizePreviewInsertions.observe(document.documentElement, { childList: true, subtree: true });
      }
    } else {
      stopSizeViewport();
      if (wasOpen) unlockSizePage();
    }
  }

  function setMobileMenuOpen(isOpen) {
    if (!menuToggle || !menuPanel) return;
    menuToggle.setAttribute("aria-expanded", isOpen ? "true" : "false");
    menuPanel.setAttribute("aria-hidden", isOpen ? "false" : "true");
    html.classList.toggle("mobile-menu-open", isOpen);
  }

  function updateSelectedSize(option) {
    if (!option) return;
    var sku = option.dataset.sku || option.dataset.title || "";
    var selection = window.PuzBoardSelection;
    if (selection && typeof selection.selectSku === "function") {
      selection.selectSku(sku, { source: "mobile-size", updateGallery: true, shouldScroll: false });
      return;
    }
    var title = option.dataset.title || sku;
    var price = option.dataset.price || "";
    var variantId = option.dataset.variantId || "";

    document.querySelectorAll("[data-mobile-selected-title]").forEach(function (element) {
      element.textContent = title;
    });
    document.querySelectorAll("[data-mobile-selected-price]").forEach(function (element) {
      element.textContent = price;
    });
    document.querySelectorAll("[data-mobile-variant-id]").forEach(function (input) {
      input.value = variantId;
    });
    document.querySelectorAll("[data-mobile-size-option]").forEach(function (button) {
      var selected = button.dataset.sku === sku;
      button.classList.toggle("is-active", selected);
      button.setAttribute("aria-pressed", selected ? "true" : "false");
    });

    Array.prototype.slice.call(document.querySelectorAll(".size[data-sku]")).some(function (desktopOption) {
      if (desktopOption.dataset.sku !== sku) return false;
      if (!desktopOption.classList.contains("active")) {
        desktopOption.click();
      }
      return true;
    });
  }

  document.addEventListener("click", function (event) {
    var menuButton = event.target.closest("[data-mobile-menu-toggle]");
    if (menuButton) {
      event.preventDefault();
      setMobileMenuOpen(menuButton.getAttribute("aria-expanded") !== "true");
      return;
    }

    if (event.target.closest("[data-mobile-menu-panel] a")) {
      setMobileMenuOpen(false);
      return;
    }

    if (html.classList.contains("mobile-menu-open") && !event.target.closest("[data-mobile-menu-scope]")) {
      setMobileMenuOpen(false);
    }

    if (event.target.closest("[data-cart-toggle]")) {
      setMobileMenuOpen(false);
    }

    var opener = event.target.closest("[data-mobile-size-sheet-open]");
    if (opener) {
      event.preventDefault();
      setMobileMenuOpen(false);
      setSheetOpen(true);
      return;
    }

    var closer = event.target.closest("[data-mobile-size-sheet-close]");
    if (closer) {
      event.preventDefault();
      setSheetOpen(false);
      return;
    }

    var option = event.target.closest("[data-mobile-size-option]");
    if (option) {
      event.preventDefault();
      updateSelectedSize(option);
      if (option.closest("[data-mobile-size-sheet]")) {
        setSheetOpen(false);
      }
    }
  });

  document.addEventListener("keydown", function (event) {
    if (event.key === "Escape") {
      setMobileMenuOpen(false);
      setSheetOpen(false);
    }
  });

  var initial = document.querySelector('[data-mobile-size-option][aria-pressed="true"]');
  // The board purchase script already initializes every surface through the shared API.
  if (initial && !window.PuzBoardSelection) {
    updateSelectedSize(initial);
  }

  collapseMobileAccordions();
  collapseMobileDisclosures();

  function scrollToBoardSizes(behavior) {
    if (window.location.hash !== "#pdp-size-guide" && window.location.hash !== "#pdp-size-guide-mobile") return;
    var targetId = isMobile() ? "pdp-size-guide-mobile" : "pdp-size-guide";
    var target = document.getElementById(targetId);
    if (!target) return;
    var disclosure = target.closest("details");
    if (disclosure) disclosure.open = true;
    window.requestAnimationFrame(function () {
      target.scrollIntoView({ behavior: behavior, block: "start" });
    });
  }

  document.addEventListener("click", function (event) {
    if (event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
    var link = event.target.closest("a[href]");
    if (!link || link.hasAttribute("download") || (link.target && link.target !== "_self")) return;
    var destination = new URL(link.href, window.location.href);
    if (destination.origin !== window.location.origin || destination.pathname !== window.location.pathname) return;
    if (destination.hash !== "#pdp-size-guide" && destination.hash !== "#pdp-size-guide-mobile") return;
    if (!document.getElementById("pdp-size-guide") && !document.getElementById("pdp-size-guide-mobile")) return;
    event.preventDefault();
    setMobileMenuOpen(false);
    if (window.location.hash !== destination.hash) window.history.pushState(null, "", window.location.pathname + window.location.search + destination.hash);
    scrollToBoardSizes("smooth");
  });

  window.addEventListener("hashchange", function () {
    scrollToBoardSizes("auto");
  });
  window.addEventListener("load", function () {
    scrollToBoardSizes("auto");
  }, { once: true });
  if (mobileQuery && mobileQuery.addEventListener) {
    mobileQuery.addEventListener("change", function () {
      if (!isMobile()) setSheetOpen(false);
      scrollToBoardSizes("auto");
    });
  }
  scrollToBoardSizes("auto");
})();
